import React from "react";
export const TRANSLATION_CONTEXT_DEFAULT_VALUES = {
    routes: {
        cart: "/warenkorb",
        checkout: "/kasse",
        missingMaterials: "/hilfe/fehlende-materialien",
        shippingAndDeliveryInformation: "/versandkosten-und-lieferzeiten",
        solution: "/loesung",
    },
    useCart: true,
};
export const TranslationContext = React.createContext(TRANSLATION_CONTEXT_DEFAULT_VALUES);
TranslationContext.displayName = "TranslationContext";
//# sourceMappingURL=context.js.map